import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { DriverModel } from './../../driver/models/driver.model';
import { DriverService } from './../../driver/models/driver.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';

@Component({
  selector: 'wego-booking-driver-popup',
  template: require('../views/booking-driver-popup.component.html'),
  providers: [DriverService]
})

export class BookingDriverPopupComponent implements OnInit, OnChanges {
  SelectedNames: string[] = [];
  SelectedList: string[] = [];
  DataListModel: DataListModel;
  driverList: DriverModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  LblIcon: string = "fa fa-plus-square";
  isParentCheck: boolean = false;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverModal') public driverModal: any;

  constructor(private driverService: DriverService
    , private authService: AuthService
    , private router: Router
    , private translate: TranslateService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(SelectedList: string[], SelectedNamesList: string[]): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.SelectedList = SelectedList;
    this.SelectedNames = SelectedNamesList;
    this.GetDriverList();
    this.driverModal.show();
  }

  public hide(): void {
    this.driverModal.hide();
  }

  private GetDriverList() {
    this.isLoading = true;
    this.driverService.GetDriverList(this.DataListModel)
      .subscribe(
      res => {
        this.driverList = res.data;
        this.driverList.forEach(x => x.isChecked =
          (this.SelectedList.indexOf(x.driverMasterHashId) > -1)
        );        
        this.isParentCheck = this.driverList.every(x => x.isChecked);
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  private select(driver: DriverModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ DriverHashID: driver.driverMasterHashId, DriverName: driver.driverName });
    this.isLoading = false;
    this.hide();
  }

  private selectMultiple(): void {
    this.isLoading = true;

    this.onSuccessSelect.emit({ DriverHashID: this.SelectedList, DriverName: this.SelectedNames });
    this.isLoading = false;
    this.hide();
  }

  private ItemCheckChanged(DriverHashID: string, DriverName: string, isChecked: any) {
    if (isChecked) {
      if (this.SelectedList.indexOf(DriverHashID) == -1) {
        this.SelectedList.push(DriverHashID);
      }
      if (this.SelectedNames.indexOf(DriverName) == -1) {
        this.SelectedNames.push(DriverName);
      }
      this.isParentCheck = this.driverList.filter(x => x.driverMasterHashId != DriverHashID).every(x => x.isChecked);
    } else {
      this.SelectedList = this.SelectedList.filter(x => x != DriverHashID);
      this.SelectedNames = this.SelectedNames.filter(x => x != DriverName);
      this.isParentCheck = false;
    }
  }

  public OnParentCheck(isChecked: boolean) {
    this.driverList.forEach(x => {
      x.isChecked = isChecked;
      if (isChecked) {
        if (this.SelectedList.indexOf(x.driverMasterHashId) == -1) {
          this.SelectedList.push(x.driverMasterHashId);
        }
        if (this.SelectedNames.indexOf(x.driverName) == -1) {
          this.SelectedNames.push(x.driverName);
        }
      } else {
        this.SelectedList = this.SelectedList.filter(y => y != x.driverMasterHashId);
        this.SelectedNames = this.SelectedNames.filter(y => y != x.driverName);
      }
    });
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDriverList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetDriverList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDriverList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDriverList();
  }
  private OnSuccessSelect() {
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-driver-popup.component.ts